import React, { createContext, useContext, useState, ReactNode } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { warmTheme, darkTheme, PaletteType } from "./theme";

interface ThemeContextType {
  paletteType: PaletteType;
  togglePalette: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
};

interface ThemeProviderProps {
  children: ReactNode;
}

export const CustomThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
}) => {
  const [paletteType, setPaletteType] = useState<PaletteType>("dark");

  const togglePalette = () => {
    setPaletteType((prev) => (prev === "warm" ? "dark" : "warm"));
  };

  const currentTheme = paletteType === "warm" ? warmTheme : darkTheme;

  return (
    <ThemeContext.Provider value={{ paletteType, togglePalette }}>
      <MuiThemeProvider theme={currentTheme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
};
